import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PageHeader from '@/components/common/PageHeader';
import OverviewPanel from './panels/OverviewPanel';
import InventoryPanel from './panels/InventoryPanel';
import GrnPanel from './panels/GrnPanel';
import DispatchPanel from './panels/DispatchPanel';
import InvoicesPanel from './panels/InvoicesPanel';

const CATEGORY_TABS = [
  { key: 'overview', Panel: OverviewPanel },
  { key: 'inventory', Panel: InventoryPanel },
  { key: 'grn', Panel: GrnPanel },
  { key: 'dispatchOrders', Panel: DispatchPanel },
  { key: 'invoices', Panel: InvoicesPanel },
] as const;

/** The single consolidated view for a Client Portal login — category tabs (Overview/Inventory/
 * GRN/Dispatch/Invoices), each with StatCards + bar/line/pie charts + a full DataTable, so
 * everything about this Client's relationship with the warehouse lives in one place. Mirrors the
 * internal Dashboard.tsx's tab structure, scoped down to the 5 categories the portal actually has
 * data for. The standalone /portal/inventory, /portal/grn, etc. nav pages stay as quick plain-table
 * views alongside this — this page is the analytical, "everything at once" one. */
export default function ClientPortalDashboardPage() {
  const { t } = useTranslation('clientPortal');
  const [tab, setTab] = useState(0);

  const ActivePanel = CATEGORY_TABS[tab]?.Panel ?? OverviewPanel;

  return (
    <>
      <PageHeader title={t('dashboardPage.title')} subtitle={t('dashboardPage.subtitle')} />

      <Box sx={{ mb: 3 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto">
          {CATEGORY_TABS.map((tabDef) => (
            <Tab key={tabDef.key} label={t(tabDef.key)} />
          ))}
        </Tabs>
      </Box>

      <ActivePanel />
    </>
  );
}
